import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M423 0v122l-59-47V0zM171 102v57H89l1-1c22-24 50-43 81-56m252 57H198V93a226 226 0 0 1 224 65zM67 187h170v86H33c5-31 17-60 34-86m412 86H268v-86h177c17 26 29 55 34 86M158 427v85H29v-85h54v31h22v-31zm325-115v86h-54v-37h-22v37h-57a98 98 0 0 0-188 0h-57v-37H83v37H29v-96h454zm0 115v85H354v-85h53v31h22v-31z",
  class: "st0"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M90 158h81v1H89z",
  class: "st0"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }